import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=8deb06d2&scoped=true&"
import script from "./PartnerView.vue?vue&type=script&lang=js&"
export * from "./PartnerView.vue?vue&type=script&lang=js&"
import style0 from "./PartnerView.vue?vue&type=style&index=0&id=8deb06d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deb06d2",
  null
  
)

export default component.exports